import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * The one tappable list row (pick a company, a person, a group, a chat).
 * 44px minimum hit target, soft hover wash, visible keyboard focus, `selected` wash.
 * Use instead of a hand-rolled <button> styled as a row.
 */
export interface ListRowButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean;
}

export const ListRowButton = React.forwardRef<HTMLButtonElement, ListRowButtonProps>(
  ({ className, selected, type = 'button', ...props }, ref) => (
    <button
      ref={ref}
      type={type}
      aria-pressed={selected}
      className={cn(
        'flex w-full min-h-11 items-center gap-3 rounded-md px-2 py-2 text-left text-sm transition-colors',
        'hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        'disabled:pointer-events-none disabled:opacity-50',
        selected && 'bg-muted',
        className,
      )}
      {...props}
    />
  ),
);
ListRowButton.displayName = 'ListRowButton';
